import { render, staticRenderFns } from "./Lamp.vue?vue&type=template&id=e3c9943c&scoped=true&"
import script from "./Lamp.vue?vue&type=script&lang=js&"
export * from "./Lamp.vue?vue&type=script&lang=js&"
import style0 from "./Lamp.vue?vue&type=style&index=0&id=e3c9943c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c9943c",
  null
  
)

component.options.__file = "Lamp.vue"
export default component.exports